import { render, staticRenderFns } from "./CatalogoCausas.vue?vue&type=template&id=5373beef&"
import script from "./CatalogoCausas.vue?vue&type=script&lang=js&"
export * from "./CatalogoCausas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports